import { useCallback } from 'react';
import { Tag } from '../Tag';
import { syntheticEvent } from '../../utils/SyntheticEvent';
import { jsx as _jsx } from "react/jsx-runtime";
export const MultiSelectValue = ({
  children,
  closeable,
  disabled,
  onClick,
  onRemove,
  value
}) => {
  const handleMouseDown = useCallback(evt => {
    if (evt.type === 'mousedown' && evt.button !== 0) {
      return;
    }
    if (evt.type === 'touchend' && evt.target.closest('[data-action="close"]')) {
      if (onRemove) {
        onRemove(value);
      }
      evt.preventDefault();
      evt.stopPropagation();
      return;
    }
    if (onClick) {
      evt.stopPropagation();
      onClick(syntheticEvent(value));
    }
  }, [onClick, onRemove, value]);
  const handleCloseMouseDown = useCallback(evt => {
    if (onRemove) {
      onRemove(value);
    }
    // Prevent input focus which can cause scroll jank
    evt.preventDefault();
    evt.stopPropagation();
  }, [onRemove, value]);
  const computedUse = value.tagUse || 'default';
  return /*#__PURE__*/_jsx(Tag, {
    closeable: typeof closeable === 'boolean' ? closeable : !disabled && value.clearableValue !== false,
    onMouseDown: handleMouseDown,
    onTouchEnd: handleMouseDown,
    use: computedUse,
    onCloseClick: handleCloseMouseDown,
    children: children
  });
};